import { useContext } from "react";
import { authContext } from "../contexts/auth";

export const useAuth = () => {
  const context = useContext(authContext);
  if (!context) {
    throw Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
